import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { Section, SectionHeading } from "./Section";
import { useT, useTx } from "@/lib/i18n-dict";
import type { FaqEntry } from "@/lib/faq-schema";

/** Visible FAQ block that backs the FAQPage structured data of a route. */
export function FaqSection({
  faqs,
  title = "Frequently asked",
  id = "faq",
}: {
  faqs: readonly FaqEntry[];
  title?: string;
  id?: string;
}) {
  const t = useT();
  const items = useTx(faqs as FaqEntry[]);
  if (!items.length) return null;
  return (
    <Section id={id}>
      <SectionHeading eyebrow={t("FAQ")} title={t(title)} />
      <Reveal className="mt-10 max-w-3xl">
        <Accordion type="single" collapsible className="w-full">
          {items.map((faq, index) => (
            <AccordionItem key={faq.q} value={`${id}-${index}`}>
              <AccordionTrigger className="text-start font-display text-base">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </Section>
  );
}
